// extracted by mini-css-extract-plugin
module.exports = {"header":"styles__header___1z-6d","close":"styles__close___V8xty"};